<template>
	<div class="root-student-container">
		<router-view></router-view>
		<!-- <div :class="['user-score-box',((!hasGroup && groupCase && groupCase.type == 20) || (hasGroup && groupCase))?'on':'']"-->
		<!-- 课堂问答，课堂讨论 -->
		<div class="showTip" @click="activityOnclick(currtActivityKey)"><p class="tip_value">老师发起了新活动</p>
		</div>
		<div class="quick_btn" :class="[currentStateType]" v-show="showBtn"
			 @click="stopClass(currentStateType)"></div>
	</div>
</template>

<script>
	import {dialog} from '@static/js/util.js';
	import studentState from "@data/AppTypeData"
	import * as cookieUtil from '@static/js/cookieUtil.js';
  import * as cookie from '@static/js/cookieUtil.js';
  import {getStudentCoursewareState, getStudentCoursewareStateNew} from '@service/getData'

	const currentTypeName = ["noSign", "class_in", "class_out", ""];
  const activityKeyValue = {"quiz": 1, "dis": 2, "freeDis": 3};
  // 不跳转的url
  const stopUrls = ['/student/group/current']
  // 课上状态的5个url
  const inClassUrls = ['/student/courseware/index', '/student/discuss/wall/', '/student/class-quiz/index/', '/student/discuss/free/', '/student/user/sign', '/student/user/app-sign'] 
	/** 学生所有页面包含当前页面 */
	export default {
		data() {
			return {
        gRefreshTask: null, // 轮询刷新登录时长
				//zmf??? 关闭多次循环
				//mAppTypeData:studentState,
				//mSignStatus : Number,
				//zmf 点击退出上课后，关闭某些挑战业务
				showBtn: false,
				beSelfOutClassClick: false,
				currtActivityKey: "",//弹出提示标志位
				currActivityInfo: { // 保存点击跳转时需要的数据
					discussId: 0,
					groupId: 0,
					frequency: 0,
					quizId: 0
				},
				aniTimer: "",
				isPopup: false, // 切换按钮是否弹出
				currentStateType: "",
				isAlert: false,
				onceInitJumpflag: false,
				courseware: {}//当前课程
			}
		},
		mounted() {
			this.setTimeHide();
			this.$bus.$off(studentState.BUS_EVENT.CLASS_IN_TASK_CLOSE).$on(studentState.BUS_EVENT.CLASS_IN_TASK_CLOSE, (data) => {
          if (!data.isToPerScore) { // 是否为跳转到个人得分页
            return
          }
          let tip = ''
          switch (data.status) {
					case studentState.STATUS.QUESTION:
						tip = '答题已结束'
						break
					case studentState.STATUS.DISCUSS:
						// tip = '讨论已停止'
						// break
					case studentState.STATUS.FREE_DISCUSS:
						tip = '讨论已停止'
						break
        }
        if (tip != '' && !this.beSelfOutClassClick) {
          weui.toast(tip, 1000)
        }
			})
		},
		methods: {
			setCurrentStateType(currentTypeName) {
				if (currentTypeName == currentTypeName[3]) {
					this.showBtn = false;
					return;
				}
				this.currentStateType = currentTypeName;
				this.showBtn = true;
			},
			showActivityTip: function () {
				$('.showTip').animate({
					right: '0'
				}, 500)
				$('.showTip').animate({
					right: '1'
				}, 3000)
				$('.showTip').animate({
					right: '-180'
				}, 1000)

			},
			activityOnclick: function (key) {
				console.log("点击活动")
				this.switch2InClass()
				switch (key) {
					case activityKeyValue.dis:
						// var route = '/student/discuss/wall/' + this.getCurrCourseware().id + '/' + this.getGroupId() + '/' + this.getDiscussId();
						// this.showConfirm('讨论', route, 'discussChange');
						this.goDiscuss(this.currActivityInfo.discussId, this.currActivityInfo.groupId)
						break;
					case activityKeyValue.quiz:
						// route = '/student/class-quiz/index/' + this.getCurrCourseware().id + "/" + this.getQuizId() + "/" + this.getQuizFrequency();
						// this.showConfirm('答题', route, 'quizChange');
						this.goQuiz(this.currActivityInfo.quizId, this.currActivityInfo.frequency)
						break;
					case activityKeyValue.freeDis:
						// route = '/student/discuss/free/' + this.getCurrCourseware().id + '/' + this.getDiscussId();
						// this.showConfirm('自由讨论', route, 'freeDiscussChange');
						this.goFreeDiscuss(this.currActivityInfo.discussId)
						break;
				}
			},
			setTimeHide: function () {
				let _this = this;
				if (_this.aniTimer) {
					clearTimeout(_this.aniTimer)
					_this.aniTimer = null;
				}
				_this.aniTimer = setTimeout(function () {
					_this.isPopup = false;
					$('.quick_btn').animate({
						right: '-50'
					}, 500)

				}, 3 * 1000);
			},
			//zmf 20200831
			stopClass: function (curType) {
				let _this = this;
				//判断是否是隐藏状态
				if (!_this.isPopup) {
					_this.isPopup = true;
					$('.quick_btn').animate({
						right: '0'
					}, 500)

					this.setTimeHide();
					return;
				}
				// this.setTimeHide();
				if (curType == currentTypeName[1]) {
          this.switch2ClassOut()
					this.clearData()
					_this.$router.replace('/student/course/list');
				} else if (curType == currentTypeName[2]) {
					this.switch2InClass()
					console.log("zmf class student pauseLoop2")
					_this.goCourseware(_this.getCurrCourseware().id, _this.getCurrCourseware().classId);
				} else if (curType == currentTypeName[0]) {
					wx.ready(function () {
						wx.scanQRCode({
							neadResult: 0,//0 微信处理 1 返回信息
							scanType: ["qrCode", "barCode"],
							success: function (res) {
								wx.closeWindow()
							}
						})
					})
				}

			},
			clearData() {
				this.setQuizFrequency(0);
				this.setQuizId(0);
				this.setDiscussId(0);
				this.setRushAnswerId(0);
			},
			switch2InClass() { // 切换到课上状态
        this.beSelfOutClassClick = false
        this.setCurrentStateType(currentTypeName[1])
      },
      switch2ClassOut () { // 切换到课下状态
        this.beSelfOutClassClick = true
        this.setCurrentStateType(currentTypeName[2])
      },
      switch2ClassEnd () { // 切换到课程结束状态
        this.setCurrCourseware(null);
        this.beSelfOutClassClick = false
        this.setCurrentStateType(currentTypeName[3])
      },
      isFirstInit () { // 是否为第一次的初始化
        if (!this.onceInitJumpflag) {
          this.onceInitJumpflag = true
          return true
        }
        return false
      },
      initClassStatus () { // 初始化课程状态
        let url = cookieUtil.getCookie("SC_COOKIE_URL")
        if (url) {
          url = decodeURIComponent(url)
        }
        for(let i in inClassUrls) {
          if (url.indexOf(inClassUrls[i]) != -1) {
            this.switch2InClass()
            return
          }
        }
        this.switch2ClassOut()
      },
      hasStopJumpUrl () { // 判断当前的页面是否为不需要跳转的页面
      let url = this.$route.path
        for(let i in stopUrls) {
          if (url.indexOf(stopUrls[i]) != -1) {
            return true
          }
        }
        return false
      },
			goCourseware: function (coursewareId, classId) {
				if (this.beSelfOutClassClick) {
					return;
				}
        if (this.isFirstInit()) { // 首次进来，不用跳转
          this.initClassStatus()
          return
        }
        if (this.hasStopJumpUrl()) { // 如果当前页面不需要跳转，则拦截
          return
        }
				return this.$router.replace('/student/courseware/index/' + coursewareId + '/' + classId);
			},
			goQuiz: function (quizId, frequency) {
				if (!quizId || !frequency) {//提问不存在或者提问未改变
					this.setQuizFrequency(0);
					this.setQuizId(0);
					return;
				}
				if (!quizId || (this.getQuizId() == quizId && this.getQuizFrequency() == frequency)) {
					return;//提问不存在或者提问未改变
        }
        if (this.isFirstInit()) { // 首次进来，不用跳转
          this.initClassStatus()
          return
        }

				this.setQuizId(quizId);
				this.setQuizFrequency(frequency);
				this.startForward();

				var route = '/student/class-quiz/index/' + this.getCurrCourseware().id + "/" + quizId + "/" + frequency;
				this.showConfirm('答题', route, 'quizChange');
			},
			goDiscuss: function (discussId, groupId) {
				if (!discussId || this.getDiscussId() == discussId) {
					return;//提问不存在或者提问未改变
        }
        if (this.isFirstInit()) { // 首次进来，不用跳转
          this.initClassStatus()
          return
        }
				if (!groupId) {
					return dialog({
						html: '你还没有加入小组，加入小组才能<br>参与老师发起的课堂讨论',
						confirmCallBack: () => {
							this.isAlert = false;
							window.location.href = origin + '/#' + '/student/group/current/jump/' + caseId;
						},
						arr: ['分组提醒', 'close', '暂不加入', "去分组"]
					});
				}
				this.setDiscussId(discussId);
				this.startForward();

				var route = '/student/discuss/wall/' + this.getCurrCourseware().id + '/' + groupId + '/' + discussId;
				this.showConfirm('讨论', route, 'discussChange');
			},
			goFreeDiscuss: function (discussId) {
				if (!discussId || this.getDiscussId() == discussId) {
					return;//提问不存在或者提问未改变
        }

        if (this.isFirstInit()) { // 首次进来，不用跳转
          this.initClassStatus()
          return
        }

				this.setDiscussId(discussId);
				this.startForward();

				var route = '/student/discuss/free/' + this.getCurrCourseware().id + '/' + discussId;
				this.showConfirm('自由讨论', route, 'freeDiscussChange');
			},
			goGroup: function (groupCase) {
				if (!groupCase || groupCase.type == 10 || groupCase.type == 21 || groupCase.type == 30) {
					this.setCurrGroupCase(null);
					return;
				}
				//同一个分组方案,只是修改小组成员,理论上应该是要刷新页面!
				if (this.getCurrGroupCase() != null && this.getCurrGroupCase().id == groupCase.id) {
					return;//提问不存在或者提问未改变
				}

				this.setCurrGroupCase(groupCase);

				var route = '/student/group/current/jump/' + groupCase.id;
				this.showConfirm('分组', route, 'groupChange');
			},
			goResponder: function (coursewareId, rushAnswerId) {

				if (!rushAnswerId) {
					this.setRushAnswerId(0);
					return;//抢答不存在或者抢答没改变
				}
				if (!rushAnswerId || this.getRushAnswerId() == rushAnswerId) {
					return;//提问不存在或者提问未改变
				}
				this.setRushAnswerId(rushAnswerId);

				var route = '/student/courseware/responder/' + coursewareId + "/" + rushAnswerId;
				return this.$router.replace(route);
				// this.showConfirm('抢答', route, 'responderChange');
			},
			goResponderResult: function (coursewareId, rushAnswerId) {

				if (!rushAnswerId) {
					this.setRushAnswerId(0);
					return;//抢答不存在或者抢答没改变
				}
				if (!rushAnswerId || this.getRushAnswerId() == rushAnswerId) {
					return;//提问不存在或者提问未改变
				}
				this.setRushAnswerId(rushAnswerId);

				var route = '/student/courseware/responder-result/' + rushAnswerId;
				// this.showConfirm('抢答', route, 'responderChange');
				return this.$router.replace(route);
			},
			closeConfirm: function () {
				var _this = this;
				var count = 60;
				if (_this.alertTimer) {
					clearInterval(_this.alertTimer);
				}
				_this.alertTimer = setInterval(function () {
					if (count <= 0) {
						_this.isAlert = false;
						clearInterval(_this.alertTimer);
					}
					count--;
				}, 1000);
				console.log('closeMsg');
				_this.$bus.$emit("closeMsg");
			},
			showConfirm: function (msg, route, signal) {
				var _this = this;
				// if(_this.isForwardPaused()){//暂停/已弹窗，跳过
				//   return;
				// }
				if (_this.$route.path == route) {
					return _this.$bus.$emit(signal);
				}
				return _this.$router.replace(route);

				if (_this.isForwardPaused() || _this.isAlert) {//暂停/已弹窗，跳过
					return;
				}
				_this.isAlert = true;//已弹窗 dd
				dialog({
					html: '老师发起了' + msg + '，请您进入' + msg,
					cancelCallBack: () => {
						_this.closeConfirm();
					},
					confirmCallBack: () => {
						_this.isAlert = false;//弹窗已关闭
						_this.pauseForward();
						if (_this.$route.path == route) {
							return _this.$bus.$emit(signal);
						}
						_this.$router.replace(route);
					},
					arr: ['上课提醒', 'close', '关闭', '确定']
				});
			},
			changeStatus2Key(status) {
				let key
				switch (status) {
					case studentState.STATUS.QUESTION:
						key = activityKeyValue.quiz;
						break
					case studentState.STATUS.DISCUSS:
						key = activityKeyValue.dis;
						break
					case studentState.STATUS.FREE_DISCUSS:
						key = activityKeyValue.freeDis;
						break
					default:
						key = ''
						break
				}
				return key
			},
			//分组信息
			loop: function () {
				var _this = this;
				//check 没有在上课状态，或者 未签到
				if (_this.isLoopPaused()) {
					return;
				}

				//获取上课中所有列表，以及课表状态，第一个最新状态
				getStudentCoursewareStateNew().then(function (response) {
					if (!response.data) {
						return console.log(response);
					}

					let coursewareList = response.data.coursewareList;
					//取第一课程作为最新状态
					if (!coursewareList || coursewareList.length < 1) {
						return _this.switch2ClassEnd()
					}

					//课程保证，最新签到的课程是第一个
					let coursewareInfo = coursewareList[0];

					if (!coursewareInfo) {
						_this.switch2ClassEnd()
						return;
					}

					let signStatus = coursewareInfo.signStatus;
					let courseware = coursewareInfo.courseware;
					let groupCase = coursewareInfo.groupCase;

					_this.setCurrCourseware(courseware);

					//增加缺勤处理
					if (courseware && (signStatus == studentState.SIGNSTATE.STUDENT_OUT_OF_CLASS_STATE || signStatus == studentState.SIGNSTATE.STUDENT_LEAVE_CLASS_STATE)) {
						if (courseware.status == studentState.STATUS.SIGN || courseware.status == studentState.STATUS.RE_SIGN) {
							_this.setCurrentStateType(currentTypeName[0]);
						} else if (courseware.status == studentState.STATUS.IN_CLASS) {
							_this.setCurrentStateType(currentTypeName[3]);
						}
						return;
						//return _this.$router.replace('/student/course/list');
					}

					// 切换到课下，且当前没有分组和抢答
					if (_this.beSelfOutClassClick
						&& courseware.status != studentState.STATUS.GROUP
						&& courseware.status != studentState.STATUS.RUSHING
						&& courseware.status != studentState.STATUS.RUSH_SCORE) {
						let key = _this.changeStatus2Key(courseware.status)
						if (_this.utils.isEmpty(key)) {
							_this.currtActivityKey = ''
						} else if (_this.currtActivityKey != key) {
							_this.currtActivityKey = key
							_this.currActivityInfo.discussId = coursewareInfo.discussId
							_this.currActivityInfo.groupId = coursewareInfo.groupId
							_this.currActivityInfo.frequency = coursewareInfo.frequency
							_this.currActivityInfo.quizId = coursewareInfo.quizId
							_this.showActivityTip();
						}
						return
					} else if (!_this.beSelfOutClassClick) {
						// 记录当前的状态，防止出现类似已经在问答内，点击切换到课下，此时却弹出新活动通知
						_this.currtActivityKey = _this.changeStatus2Key(courseware.status)
					}

					//已经签到
					if (courseware.status == studentState.STATUS.IN_CLASS) {//上课
						_this.setCurrentStateType(currentTypeName[1]);
						return _this.goCourseware(courseware.id, courseware.classId);
					}

					//缺勤状态
					if(signStatus == studentState.SIGNSTATE.STUDENT_OUT_OF_CLASS_STATE){
						_this.setCurrentStateType(currentTypeName[0]);
						return _this.$router.replace('/student/course/list');
					}

					//增加授课端签到页面提示->保证签到页面时候,显示对应界面后,
					if (signStatus == studentState.SIGNSTATE.STUDENT_NO_SIGHT && (courseware.status == studentState.STATUS.SIGN || courseware.status == studentState.STATUS.RE_SIGN)) {
						_this.setCurrentStateType(currentTypeName[0]);
						return;
					} else if (signStatus == studentState.SIGNSTATE.STUDENT_NORMAL_CLASS_STATE && (courseware.status == studentState.STATUS.SIGN || courseware.status == studentState.STATUS.RE_SIGN)) {
						_this.setCurrentStateType(currentTypeName[1]);
						return _this.goCourseware(courseware.id, courseware.classId);
					}

					if (courseware.status == studentState.STATUS.QUESTION) {//提问
						_this.setDiscussId(0);
						_this.setClickFlag(false);
						_this.setCurrentStateType(currentTypeName[1]);
						_this.goQuiz(coursewareInfo.quizId, coursewareInfo.frequency);
					} else {//退出答题 清空quizId
						_this.setQuizId(0);
						_this.setQuizFrequency(0);
						//提问也是上课中
						_this.setCurrentStateType(currentTypeName[1]);
					}

					if (courseware.status == studentState.STATUS.DISCUSS || courseware.status == studentState.STATUS.DISCUSS_PAUSE) {//讨论
						_this.setCurrentStateType(currentTypeName[1]);
						_this.setGroupId(coursewareInfo.groupId);
						_this.goDiscuss(coursewareInfo.discussId, coursewareInfo.groupId);
					}

					if (courseware.status == studentState.STATUS.FREE_DISCUSS || courseware.status == studentState.STATUS.FREE_DISCUSS_PAUSE) {//自由讨论
						_this.setCurrentStateType(currentTypeName[1]);
						_this.setGroupId(coursewareInfo.groupId);
						_this.goFreeDiscuss(coursewareInfo.discussId, coursewareInfo.groupId);

					}

					if (courseware.status == studentState.STATUS.GROUP) {//分组
						_this.setDiscussId(0);
						_this.setClickFlag(false);
						_this.setGroupId(coursewareInfo.groupId);
						_this.switch2InClass()
						_this.goGroup(groupCase);
					}

					if (courseware.status == studentState.STATUS.RUSHING) {//抢答 27抢答中;
						_this.setDiscussId(0);
						_this.setClickFlag(false);
						_this.switch2InClass()
						_this.goResponder(courseware.id, coursewareInfo.rushAnswerId);
					}
					if (courseware.status == studentState.STATUS.RUSH_SCORE) {//28抢答加分中;
						_this.setDiscussId(0);
						_this.setClickFlag(false);
						_this.switch2InClass()
						_this.goResponderResult(courseware.id, coursewareInfo.rushAnswerId);
					}

					if (signStatus > studentState.SIGNSTATE.STUDENT_NORMAL_CLASS_STATE) {
						_this.setCurrentStateType(currentTypeName[3]);
						return;
					} else if (signStatus == studentState.SIGNSTATE.STUDENT_NO_SIGHT) {
						_this.setCurrentStateType(currentTypeName[0]);
						return;
					}

					if (courseware.status > studentState.STATUS.IN_CLASS && courseware.status < studentState.STATUS.OUT_CLASS) {//
						if (courseware.status != _this.getCurrCourseware().status) {//status 改变 临时弹窗
							console.log('临时弹窗' + courseware.status + ' ' + _this.getCurrCourseware().status);
							_this.startForward();
						}
					}

					if (groupCase) {
						if (_this.getCurrGroupCase() && _this.getCurrGroupCase().id != groupCase.id) {
							_this.setGroupId(coursewareInfo.groupId);
							_this.goGroup(groupCase);//分组方案改变，弹窗提示
						}
						_this.setCurrGroupCase(groupCase);
					}
				})

				//_this.$axios.post(_this.stuApiUrl + "/course/status", _this.$qs.stringify({}))
				// getStudentCoursewareState()
				// 	.then(function (response) {
				// 		if (!response.data.success) {
				// 			return console.log(response);
				// 		}
				// 		var courseware = response.data.courseware;
				// 		var signStatus = response.data.signStatus;
				// 		var groupCase = response.data.groupCase;
				//
				// 		//更新状态
				// 		_this.mSignStatus = signStatus;
				// 		_this.courseware = courseware;
				//
				// 		//if (!courseware || signStatus != STUDENT_NORMAL_CLASS_STATE || courseware.status == COURSEWARE_STATUS.OUT_CLASS) {
				// 		if (!courseware || signStatus != studentState.SIGNSTATE.STUDENT_NORMAL_CLASS_STATE) {
				// 			//未签到/未在上课，关闭轮询
				// 			//zmf 20200831 添加上课类型，显示按钮
				// 			_this.currentStateType = currentTypeName[3];
				// 			_this.pauseLoop(); //在签到页面会打开
				// 			console.log("zmf class student pauseLoop")
				// 			return _this.$router.replace('/student/course/list');
				// 		}
				//
				// 		// 1.x代码逻辑混乱问题 zmf 去除该部分
				// 		// if(!courseware){
				// 		//   return;//同步不到数据 重置课程状态
				// 		// }
				// 		//
				// 		//
				// 		// if (!courseware || signStatus != studentState.STATUS.WAITE) {
				// 		// 			//未签到/未在上课，关闭轮询
				// 		//   //zmf 20200831 添加上课类型，显示按钮
				// 		//   _this.currentStateType = currentTypeName[0];
				// 		//   _this.pauseLoop(); //在签到页面会打开
				// 		// return _this.$router.replace('/student/course/list');
				// 		// }
				//
				// 		if (signStatus != studentState.STATUS.WAITE) {
				// 			_this.currentStateType = currentTypeName[3];
				// 			return _this.pauseLoop();
				// 		}
				//
				// 		if (courseware.status == studentState.STATUS.IN_CLASS && !_this.getClickFlag()) {//上课
				// 			_this.currentStateType = currentTypeName[1];
				// 			return _this.goCourseware(courseware.id, courseware.classId);
				// 		}
				//
				// 		//增加授课端签到页面提示
				// 		if (courseware.status == studentState.STATUS.SIGN || courseware.status == studentState.STATUS.RE_SIGN) {
				// 			_this.currentStateType = currentTypeName[0];
				// 		}
				//
				// 		if (courseware.status == studentState.STATUS.QUESTION) {//提问
				// 			_this.setDiscussId(0);
				// 			_this.setClickFlag(false);
				// 			_this.goQuiz(response.data.quizId, response.data.frequency);
				// 		} else {//退出答题 清空quizId
				// 			_this.setQuizId(0);
				// 			_this.setQuizFrequency(0);
				// 		}
				//
				// 		if (courseware.status == studentState.STATUS.DISCUSS || courseware.status == studentState.STATUS.DISCUSS_PAUSE) {//讨论
				// 			_this.goDiscuss(response.data.discussId, response.data.groupId);
				// 		}
				//
				// 		if (courseware.status == studentState.STATUS.FREE_DISCUSS || courseware.status == studentState.STATUS.FREE_DISCUSS_PAUSE) {//自由讨论
				// 			_this.goFreeDiscuss(response.data.discussId, response.data.groupId);
				// 			//zmf 增加提示
				// 			_this.showActivityTip();
				// 		}
				//
				// 		if (courseware.status == studentState.STATUS.GROUP) {//分组
				// 			_this.setDiscussId(0);
				// 			_this.setClickFlag(false);
				// 			_this.goGroup(groupCase);
				// 			//zmf 增加提示
				// 			_this.showActivityTip();
				// 		}
				//
				// 		if (courseware.status == studentState.STATUS.RUSHING) {//抢答 27抢答中;
				// 			_this.setDiscussId(0);
				// 			_this.setClickFlag(false);
				// 			//zmf 增加提示
				// 			_this.showActivityTip();
				// 			_this.goResponder(courseware.id, response.data.rushAnswerId);
				// 		}
				// 		if (courseware.status == studentState.STATUS.RUSH_SCORE) {//28抢答加分中;
				// 			_this.setDiscussId(0);
				// 			_this.setClickFlag(false);
				// 			_this.goResponderResult(courseware.id, response.data.rushAnswerId);
				// 		}
				//
				// 		if (courseware.status > studentState.STATUS.IN_CLASS && courseware.status < studentState.STATUS.OUT_CLASS) {//
				// 			if (courseware.status != _this.getCurrCourseware().status) {//status 改变 临时弹窗
				// 				console.log('临时弹窗' + courseware.status + ' ' + _this.getCurrCourseware().status);
				// 				_this.startForward();
				// 			}
				// 		}
				//
				// 		if (groupCase) {
				// 			if (_this.getCurrGroupCase() && _this.getCurrGroupCase().id != groupCase.id) {
				// 				_this.goGroup(groupCase);//分组方案改变，弹窗提示
				// 			}
				// 			_this.setCurrGroupCase(groupCase);
				// 		}
				// 		// zmf 20200831 由于需要根据该条件判断按钮状态，故移到上面
				// 		//_this.courseware = courseware;
				// 		_this.setCurrCourseware(courseware);
				// 		_this.setTimeHide();
				// 	}).catch(function (error) {
				// 	console.log("课程状态错误：" + error);
				// });
      },
      refreshTask() {
				this.$axios.post(this.webHost + "/refresh",
					this.$qs.stringify({user: this.userId, client: 'WCHAT'}))
					.then(response => {

					})
					.catch(error => {
						console.log(error)
					})
			}  
		},
		created() {
			var _this = this;
			var origin = window.location.origin;
      _this.origin = origin;
      this.loop()
      _this.Gloop = setInterval(_this.loop, 5000);
      this.gRefreshTask = setInterval(this.refreshTask, 1000 * 60 * 10)
		},
		beforeDestroy() {
			this.Gloop && clearInterval(this.Gloop);
      this.aniTimer && clearTimeout(this.aniTimer)
      this.gRefreshTask && clearInterval(this.gRefreshTask)
			this.$bus.$off(studentState.BUS_EVENT.CLASS_IN_TASK_CLOSE)
		}
	}
</script>


<style scoped lang="scss">
	body {
		background: rgba(251, 251, 251, 1);
	}

	.root-student-container {
		height: 100%;
		overflow: auto;
	}

	.quick_btn {
		position: fixed;
		right: 0px;
		bottom: 80px;
		background-repeat: no-repeat;
		width: 80px;
		height: 100px;
		z-index: 99;
	}

	.showTip {
		position: fixed;
		right: -180px;
		bottom: 180px;
		background-repeat: no-repeat;
		width: 120px;
		height: 40px;
		text-align: center;
		background-image: url('../.././static/images/uclass/new_activity.svg');
		/*visibility: hidden;*/
	}

	.showTip .tip_value {
		color: white;
		line-height: 15px;
		text-align: center;
		top: 50%;
		position: absolute;
		margin-top: -10px;
		margin-left: 10px;

	}

	.noSign {
		background-image: url('../.././static/images/uclass/clsss_siginin.svg');
	}

	.class_in {
		background-image: url('../.././static/images/uclass/class_home.svg');
	}

	.class_out {
		background-image: url('../.././static/images/uclass/classing.svg');
	}

</style>



// WEBPACK FOOTER //
// src/frame/student.vue